import { addons } from "@storybook/manager-api";
// or a custom theme
import { themes } from "@storybook/theming";

addons.setConfig({
  theme: themes.dark,
});
